﻿import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/tab";
import {cancelDialog} from "../helpers/dialogs";
import {DateRangePicker} from "vanillajs-datepicker";
import Swal from "sweetalert2";

export const initBooking = () => {
  const cancelBooking = (bookingId: string, refundType: string,  paymentProvider: string) => {
    Swal.fire({
      title: "Processing cancellation of booking",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();

        fetch(`/bookings/cancel?id=${bookingId}&refundType=${refundType}`, {
          method: "POST",
          body: null,
          headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"}
        })
          .then(response => response.json())
          .then(response => {
            if (!response.success) {
              Swal.fire({
                  title: "Booking cancellation (partly) failed",
                  text: "Cancellation was not completed successfully. Check the booking for the actual status, including any alerts."
                }
              ).then(_ => {
                location.reload();
              });
            } else {
              // Everything is OK
              const successMessage = paymentProvider == "Mollie"
                ? "Refunding (if applicable) is in progress and can still be canceled using Mollie for the next 120 minutes. After that it can take up to 2 working days before customer receives refund."
                : "Refunding (if applicable) is in progress. When payment method is Ideal or Bancontact it can still be canceled using Pay for the next 10 hours. After that it can take up to 2 working days before customer receives refund.";

              Swal.fire({
                title: "Booking successfully canceled!",
                html: successMessage,
                icon: "success",
                buttonsStyling: false,
                customClass: {
                  confirmButton: 'btn-primary'
                }
              }).then(_ => {
                location.reload();
              });
            }
          })
          .catch(error => {
            Swal.fire({
                title: "Booking cancellation (partly) failed",
                text: "Cancellation was not completed successfully. Check the booking for the actual status, including any alerts."
              }
            ).then(_ => {
              location.reload();
            });
          });
      }
    });
  };

  const initButtons = () => {
    document.querySelector(".js-booking-cancel")?.addEventListener("click", event => {
      const el = event.target as HTMLElement;
      const bookingId = el.dataset.bookingId;
      const bookingCode = el.dataset.bookingCode;
      const paymentProvider = el.dataset.paymentProvider;

      cancelDialog(
        `Cancel booking #${bookingCode}?`,
        "Are you sure you want to cancel this booking?",
        "Yes, cancel this booking!",
        () => cancelBooking(bookingId, "AccordingToConditions", paymentProvider)
      );
    });

    document.querySelector(".js-booking-cancel-with-full-refund")?.addEventListener("click", event => {
      const el = event.target as HTMLElement;
      const bookingId = el.dataset.bookingId;
      const paymentProvider = el.dataset.paymentProvider;

      cancelDialog(
        "Cancel with FULL refund",
        "The booking will be cancelled with full refund and the cancellation conditions will be disregarded.",
        "Yes, cancel this booking!",
        () => cancelBooking(bookingId, "Full", paymentProvider),
        undefined,
        "No"
      );
    });

    document.querySelector(".js-booking-cancel-with-no-refund")?.addEventListener("click", event => {
      const el = event.target as HTMLElement;
      const bookingId = el.dataset.bookingId;
      const paymentProvider = el.dataset.paymentProvider;

      cancelDialog(
        "Cancel with NO refund",
        "The booking will be cancelled with no refund and the cancellation conditions will be disregarded.",
        "Yes, cancel this booking!",
        () => cancelBooking(bookingId, "None", paymentProvider),
        undefined,
        "No"
      );
    });

    document.querySelectorAll(".js-booking-unflag-alert").forEach(button => button.addEventListener("click", event => {
      const el = event.target as HTMLElement;
      const alertId = el.dataset.alertId;

      Swal.fire({
        title: "Please wait",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: async () => {
          Swal.showLoading();

          try {
            await fetch(`/bookings/unflag-alert?id=${alertId}`, {
              method: "POST",
              body: null,
              headers: {"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"}
            });

            location.reload();
          } catch (error) {
            alert(error);
          }
        }
      });
    }));
  };

  const initDateRangePicker = () => {
    const el = document.getElementById("search-booking-range");

    if (!el) {
      return;
    }

    new DateRangePicker(el, {
      // @ts-ignore
      autohide: true,
      buttonClass: "btn",
      clearButton: true,
      format: "yyyy-mm-dd",
      allowOneSidedRange: true
    });
  };

  initDateRangePicker();
  initButtons();
};
